(function initCountryMarketModal() {
  if (window.__gcCountryMarketModalInit) return;
  window.__gcCountryMarketModalInit = true;

  if (window.location.search.includes('country=')) {
    const url = new URL(window.location.href);
    url.searchParams.delete('country');
    window.history.replaceState({}, '', url.toString());
  }

  const closeCountryList = (modal) => {
    const countryList = modal.querySelector('[data-country-picker-list]');
    const countryTrigger = modal.querySelector('[data-country-picker-trigger]');
    if (countryList && countryTrigger) {
      countryList.hidden = true;
      countryTrigger.setAttribute('aria-expanded', 'false');
    }
  };

  const closeModal = (root) => {
    const trigger = root.querySelector('[data-country-market-open]');
    const modal = root.querySelector('[data-country-market-modal]');
    if (!trigger || !modal) return;

    modal.classList.remove('is-open');
    modal.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    closeCountryList(modal);

    if (root._previousActiveElement) {
      root._previousActiveElement.focus();
    }
  };

  const openModal = (root) => {
    const trigger = root.querySelector('[data-country-market-open]');
    const modal = root.querySelector('[data-country-market-modal]');
    if (!trigger || !modal || trigger.disabled) return;

    root._previousActiveElement = document.activeElement;
    modal.hidden = false;
    modal.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    const firstField = modal.querySelector('select, button, input');
    if (firstField) firstField.focus();
  };

  const bindSwitch = (root) => {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const trigger = root.querySelector('[data-country-market-open]');
    const modal = root.querySelector('[data-country-market-modal]');
    if (!trigger || !modal) return;

    trigger.addEventListener('click', () => openModal(root));

    modal.querySelectorAll('[data-country-market-close]').forEach((element) => {
      element.addEventListener('click', () => closeModal(root));
    });

    const form = modal.querySelector('form');
    if (form) {
      form.addEventListener('submit', (event) => {
        const externalInput = form.querySelector('[data-market-external-url]');
        const externalUrl = externalInput && externalInput.value ? externalInput.value.trim() : '';

        if (externalUrl) {
          event.preventDefault();
          window.location.href = externalUrl;
          return;
        }

        const returnToInput = form.querySelector('input[name="return_to"]');
        if (returnToInput && returnToInput.value.includes('?')) {
          const [path, query] = returnToInput.value.split('?');
          const params = new URLSearchParams(query);
          params.delete('country');
          const cleanedQuery = params.toString();
          returnToInput.value = cleanedQuery ? `${path}?${cleanedQuery}` : path;
        }
      });
    }

    const countryPicker = modal.querySelector('[data-country-picker]');
    if (!countryPicker) return;

    const countryTrigger = countryPicker.querySelector('[data-country-picker-trigger]');
    const list = countryPicker.querySelector('[data-country-picker-list]');
    const input = countryPicker.querySelector('[data-country-picker-input]');
    const label = countryPicker.querySelector('[data-country-picker-label]');
    const flag = countryPicker.querySelector('[data-country-picker-flag]');
    const handleInput = countryPicker.querySelector('[data-market-picker-handle]');
    const externalInput = countryPicker.querySelector('[data-market-external-url]');
    const options = countryPicker.querySelectorAll('.country-picker__option');

    const openCountryList = () => {
      list.hidden = false;
      countryTrigger.setAttribute('aria-expanded', 'true');
    };

    const hideCountryList = () => {
      list.hidden = true;
      countryTrigger.setAttribute('aria-expanded', 'false');
    };

    countryTrigger.addEventListener('click', () => {
      if (list.hidden) {
        openCountryList();
      } else {
        hideCountryList();
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        const optionLabel = option.dataset.label || '';
        const flagUrl = option.dataset.flag;
        const flagIso = option.dataset.flagIso || value || 'US';
        const marketHandle = option.dataset.marketHandle || '';
        const externalUrl = option.dataset.externalUrl || '';

        if (input) input.value = value || '';
        if (label) label.textContent = optionLabel;
        if (handleInput) handleInput.value = marketHandle;
        if (externalInput) externalInput.value = externalUrl;

        if (flag && flagUrl) {
          flag.style.setProperty('--background-image', `url(${flagUrl})`);
          flag.className = `f-country-flags f-country-flags--${flagIso}`;
        }

        options.forEach((item) => {
          const isSelected = item === option;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        hideCountryList();
      });
    });

    document.addEventListener('click', (event) => {
      if (!countryPicker.contains(event.target)) {
        hideCountryList();
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-country-market-switch]').forEach(bindSwitch);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-country-market-switch]').forEach((root) => {
      const modal = root.querySelector('[data-country-market-modal]');
      if (modal && modal.classList.contains('is-open')) {
        closeModal(root);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
